import React from 'react';
import { Link } from 'react-router-dom';

const ContactPage: React.FC = () => {
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
            {/* Header - consistent with App.tsx but simplified */}
            <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
                    <div className="flex items-center justify-between">
                        <h1 className="text-xl font-bold text-gray-900 dark:text-white">
                            Contact Us
                        </h1>
                        <Link
                            to="/"
                            className="text-sm text-blue-600 dark:text-blue-400 hover:underline"
                        >
                            Back to Directory
                        </Link>
                    </div>
                </div>
            </header>

            <main className="flex-grow max-w-3xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8">
                <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden">
                    <div className="p-6 sm:p-8">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
                            Get in Touch
                        </h2>

                        <div className="space-y-6">
                            <div>
                                <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                                    General Inquiries
                                </h3>
                                <p className="text-gray-600 dark:text-gray-300">
                                    For general questions about the intranet or SSD resources, please contact the IT department.
                                </p>
                                <div className="mt-3 flex items-center text-gray-600 dark:text-gray-300">
                                    <svg className="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                    <a href="mailto:it@ssdemail.com" className="text-blue-600 dark:text-blue-400 hover:underline">
                                        it@ssdemail.com
                                    </a>
                                </div>
                            </div>

                            <div className="border-t border-gray-200 dark:border-gray-700 pt-6">
                                <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                                    HR Support
                                </h3>
                                <p className="text-gray-600 dark:text-gray-300">
                                    For questions regarding HR, benefits, or payroll.
                                </p>
                                <div className="mt-3 flex items-center text-gray-600 dark:text-gray-300">
                                    <svg className="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                    <a href="mailto:hr@ssdemail.com" className="text-blue-600 dark:text-blue-400 hover:underline">
                                        hr@ssdemail.com
                                    </a>
                                </div>
                            </div>

                            <div className="border-t border-gray-200 dark:border-gray-700 pt-6">
                                <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                                    Office Locations
                                </h3>
                                <div className="grid gap-4 sm:gap-6 sm:grid-cols-2">
                                    <div className="bg-gray-50 dark:bg-gray-700/50 p-4 rounded-lg">
                                        <h4 className="font-semibold text-gray-900 dark:text-white">Main Office</h4>
                                        <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">
                                            123 Dermatology Lane<br />
                                            Suite 100<br />
                                            Valid City, ST 12345
                                        </p>
                                        <p className="text-sm text-gray-600 dark:text-gray-300 mt-2">
                                            (555) 123-4567
                                        </p>
                                    </div>
                                    {/* Add more locations as needed */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default ContactPage;
